// AI Agent 流式调用统计上报（后端 ProxyServer AgentStreamStatController，/api/agent/stream/stats）
const STREAM_STATS_URL = (import.meta.env.VITE_API_BASE as string || '') + '/api/agent/stream/stats';

export interface AgentStreamStatPayload {
  conversationId: string;
  agentType: number;
  message: string;
  status: 'success' | 'error';
  error?: string;
  t1Ms: number;
  t2Ms: number;
  /** 当前访问域名；缺省时自动取 window.location.hostname */
  domain?: string;
}

function getCurrentDomain(): string {
  try {
    return (typeof window !== 'undefined' && window.location?.hostname) || '';
  } catch {
    return '';
  }
}

/**
 * 流结束后单次上报统计。fire-and-forget：失败静默，不阻塞主流程、不重试。
 */
export async function reportAgentStreamStat(payload: AgentStreamStatPayload): Promise<void> {
  try {
    await fetch(STREAM_STATS_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ appId: 'fateuni', ...payload, domain: payload.domain || getCurrentDomain() }),
    });
  } catch {
    // 静默忽略（网络/服务异常不影响主流程）
  }
}
